


































































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { Consulta } from '../../../../back/src/entity/Consulta';

import CustomDialog from '../CustomDialog.vue';
import TheConsultasFormCancelar from './TheConsultasFormCancelar.vue';

export default Vue.extend({
  name: 'TheConsultasTabelaAgendadas',
  components: {
    CustomDialog,
    TheConsultasFormCancelar,
  },
  props: {
    consultas: {
      type: Array as () => Consulta[],
    },
  },
  data() {
    return {
      dialogCancelarConsulta: false,
      consultaSelecionada: null,
    };
  },
  computed: {
    headers() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          {
            value: 'datetime_agendamento',
            text: 'Data agendamento',
            sortable: true,
          },
          {
            value: 'consulta_coletiva_id',
            text: 'Coletiva',
            sortable: false,
            align: 'center',
          },
          {
            value: 'actions',
            text: 'Ações',
            sortable: false,
            align: 'right',
          },
        ];
      }
      return [
        {
          value: 'datetime_agendamento',
          text: 'Data agendamento',
          sortable: true,
          class: 'text-no-wrap',
        },
        {
          value: 'created',
          text: 'Agendado em',
          sortable: false,
          class: 'text-no-wrap',
          align: 'center',
        },
        {
          value: 'usuario_created_by',
          text: 'Agendado por',
          sortable: false,
          class: 'text-no-wrap',
          align: 'center',
        },
        {
          value: 'consulta_coletiva_id',
          text: 'Coletiva',
          sortable: false,
          class: 'text-no-wrap',
          align: 'center',
        },
        {
          value: 'actions',
          text: 'Ações',
          sortable: false,
          class: 'text-no-wrap',
          width: 0,
          align: 'center',
        },
      ];
    },
  },
  methods: {
    cancelaConsulta(consulta: Consulta) {
      this.$emit('cancelaConsulta', consulta);
      this.dialogCancelarConsulta = false;
    },
    linkConsultasAtender(consultaId: number) {
      return {
        name: 'ConsultasAtender',
        params: { consultaId },
      };
    },
    linkConsultasVer(consultaId: number) {
      return {
        name: 'ConsultasVer',
        params: { consultaId },
      };
    },
    linkConsultaColetiva(consultaColetivaId: number) {
      return {
        name: 'ConsultaColetivaAtiva',
        params: { consultaColetivaId },
      };
    },
    diffDays(datetimeAgendamento: Date | string) {
      return moment(datetimeAgendamento).diff(moment(), 'days');
    },
    tableRowClass(datetimeAgendamento: Date | string) {
      if (this.diffDays(datetimeAgendamento) < 0) {
        return 'error lighten-2';
      }
      if (this.diffDays(datetimeAgendamento) === 0) {
        return 'success lighten-2';
      }
      return '';
    },
  },
});
